import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFCoreEntities } from '@pf/shared-common';
import { UserPositionRead } from '../../entities/user-position.dto';
@Injectable()
export class UserPositionStore extends AbstractEntityStore<UserPositionRead> {
    constructor() {
        super(PFCoreEntities.UserPosition);
    }
}
